import { useMemo } from "react";

import { useLocation } from "react-router";

import { Path } from "~/v2/path";

const PATHS = {
  ACH: {
    withdraw: Path.ROUTE_FUNDING_WITHDRAW_ACH,
    deposit: Path.ROUTE_FUNDING_DEPOSIT_ACH,
  },
  Wire: {
    withdraw: Path.ROUTE_FUNDING_WITHDRAW_WIRE,
    deposit: Path.ROUTE_FUNDING_DEPOSIT_WIRE,
  },
  CurrencyCloud: {
    withdraw: Path.ROUTE_FUNDING_WITHDRAW_CURRENCYCLOUD,
    deposit: Path.ROUTE_FUNDING_DEPOSIT_CURRENCYCLOUD,
  },
};

const getPath = (
  type: "ACH" | "Wire" | "CurrencyCloud",
  direction: "withdraw" | "deposit",
) => {
  return PATHS[type][direction];
};

export const useGetPaths = (
  type: "ACH" | "Wire" | "CurrencyCloud",
  // Optional explicit search string. The Plaid OAuth-resume page passes the
  // PERSISTED `?transfer=` from before the redirect so deposit/withdraw targets
  // are derived from the original intent, not the live (oauth_state_id) URL.
  searchOverride?: string,
) => {
  const { search: locationSearch } = useLocation();
  const search = searchOverride ?? locationSearch;

  const paths = useMemo(() => {
    const params = new URLSearchParams(search);
    const direction = params.get("transfer");

    if (!direction || (direction !== "deposit" && direction !== "withdraw")) {
      return { next: Path.ROUTE_FUNDING, back: Path.ROUTE_FUNDING };
    }

    return {
      next: getPath(type, direction),
      back:
        direction === "deposit"
          ? Path.ROUTE_FUNDING_DEPOSIT
          : Path.ROUTE_FUNDING_WITHDRAW,
    };
  }, [search, type]);

  return paths;
};
